import React, { useState, useRef } from 'react';
import { Play } from 'lucide-react';

interface CourseVideoPlayerProps {
  slug: string;
  moduleNumber?: number;
}

const CourseVideoPlayer: React.FC<CourseVideoPlayerProps> = ({ slug, moduleNumber }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasError, setHasError] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const videoSrc = `/videos/generated/course-${slug}.mp4`;

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  if (hasError) return null;

  return (
    <div className="my-8">
      <div className="relative rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-primary-900">
        <video
          ref={videoRef}
          src={videoSrc}
          className="w-full h-auto block"
          style={{ aspectRatio: '16/9' }}
          onError={() => setHasError(true)}
          onEnded={() => setIsPlaying(false)}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          controls
          playsInline
          preload="metadata"
        />
        {!isPlaying && (
          <button
            onClick={handlePlay}
            className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/20 transition-all group"
            aria-label="Play video"
          >
            <div className="w-16 h-16 rounded-full bg-accent-500/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
              <Play className="w-7 h-7 text-white ml-1" />
            </div>
          </button>
        )}
      </div>
      <p className="text-center text-sm text-gray-500 mt-3">
        {moduleNumber ? `Module ${moduleNumber} — ` : ''}90-second video overview
      </p>
    </div>
  );
};

export default CourseVideoPlayer;
